const Rewards = () => (
    <svg
        width='60'
        height='59'
        viewBox='0 0 60 59'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M29.6812 15.2761C29.6812 15.2761 25.7267 -2.51898 13.8634 3.4127C2 9.34437 29.6812 15.2761 29.6812 15.2761ZM29.6812 15.2761C29.6812 15.2761 33.6356 -2.51898 45.499 3.4127C57.3623 9.34437 29.6812 15.2761 29.6812 15.2761ZM29.6812 15.2761V56.7978M5.95445 25.1622V56.7978H53.4079V25.1622H5.95445ZM2 15.2761V25.1622H57.3623V15.2761H2Z'
            stroke='#00A6FF'
            strokeWidth='3.51507'
            strokeLinecap='round'
            strokeLinejoin='round'
        />
    </svg>
);

export default Rewards;
